// How a Social Security Number reads once it's recorded (OLIO-2586).
//
// The full number is shown in exactly one place — the entry form, where someone has to be able to
// read what they're confirming or correcting. Every read-only surface uses this instead: the
// extraction card and the referral header today, and anywhere else it turns up later.
//
// The format lives here alone so changing it is one edit rather than a hunt.

const LAST_FOUR = 4;

// "***-**-1234" per the mock. Digits are pulled out first because a packet may state it as
// 123-45-6789 or 123456789 and both should mask identically. Anything too short to have a last
// four is masked whole rather than partially revealed — a 3-digit fragment showing in full is
// worse than a row that reads as redacted.
export function maskSsn(value: string | null | undefined): string {
  const digits = (value ?? '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length < LAST_FOUR) return '***-**-****';

  return `***-**-${digits.slice(-LAST_FOUR)}`;
}
